import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import Axios from "axios";

const routePrefix = "/simulatiedossier/";

const simulatieDossierApi = {
	get(simulatieDossierId) {
		const serviceUrl = prependRoot(routePrefix + simulatieDossierId, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	loadEmptySimulatieDossier() {
		const serviceUrl = prependRoot(routePrefix + 'empty', getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	loadEmptyInfrastructuur() {
		const serviceUrl = prependRoot(routePrefix + "infrastructuur/new", getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	save(simulatieDossier) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return Axios.put(serviceUrl, simulatieDossier, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	validateInfrastructuur(infrastructuur) {
		const serviceUrl = prependRoot(routePrefix + "validateinfrastructuur/", getApiRoot());
		return Axios.put(serviceUrl, infrastructuur, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	generateRapport(dossierId) {
		const serviceUrl = prependRoot(routePrefix + "rapport/" + dossierId, getApiRoot());
		let returnValue = Axios.post(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	getInfrastructurenInDeBuurt(lengtegraad, breedtegraad) {
		const serviceUrl = prependRoot(routePrefix + lengtegraad + "/" + breedtegraad, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	}
};

export default simulatieDossierApi;
